<div>
  @for (insurancePackage of insurancePackages(); track $index) {
    <insurance-packages-item [insurancePackage]="insurancePackage"></insurance-packages-item>
  }
</div>
